import Axios from 'axios';
import {localStore} from '../redux/store';

export const authorize = () => Axios.post(`${process.env.REACT_APP_BASE_URL_SITE_API}/authorize`);
export const login = (username, password) => Axios.post(`${process.env.REACT_APP_BASE_URL_SITE_API}/login`, { username, password });
export const refresh = () => Axios.post(`${process.env.REACT_APP_BASE_URL_SITE_API}/refresh`, { token: localStore.getState().oauth.refreshToken });